import React, {Fragment} from 'react'
import { currentLang, farmerURL } from '../../../utils/functions'
import { useTranslation } from 'react-i18next'

function FarmerBanner({data}) {
    const { t } = useTranslation();
    const url = farmerURL((data.farmer_is_new == 1 ? t("farmers.newfarmerslug")+"/"+t(data.farmer_animal) : data.farmer_slug));
    //console.log(data);
    return (
        <fragment>
        <div className="module__farmer">
            <div className="module__farmer__bg">
                {data.farmer_header_image_url &&
                    <img src={data.farmer_header_image_url} />
                }
            </div>
            <div className="module__farmer__body">
                <div className="container">
                    <div className="row">
                        <div className="col">

                            <div className="module__farmer__info">
                                <div className="module__farmer__image">
                                    {data.farmer_image_url ? <img src={data.farmer_image_url} /> : <span className="icon-farmers"></span>}
                                </div>
                                <div className="module__farmer__text">
                                    <div className="badge">
                                        <div className="badge__item location"> <span className="icon-location"></span> {data.farmer_location} </div>
                                    </div>
                                    <div className="module__farmer__name">
                                        <h2 className="heading--h2">
                                            <a href={url}>
                                                {data.farmer_title}
                                            </a>
                                        </h2>
                                        <div className="module__farmer__cta">
                                            {['game', 'roe', 'deer', 'boar'].includes(data.animal) &&
                                                <a className="btn btn--red" href={url}>{t("farmers.readmoreaboutfarmer_deer")}</a>
                                            }
                                            {['fish', 'salmon'].includes(data.animal) &&
                                                <a className="btn btn--red" href={url}>{t("farmers.readmoreaboutfarmer_fish")}</a>
                                            }
                                            {!['game', 'roe', 'deer', 'boar', 'fish', 'salmon'].includes(data.animal) &&
                                                <a className="btn btn--red" href={url}>{t("farmers.readmoreaboutfarmer")}</a>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="module__farmer__expand"></div>
        </fragment>
    )
}

export default FarmerBanner
